<template>
  <TheHeader />

  <TheMain>
    <RouterView />
  </TheMain>

  <TheFooter />
</template>

<script lang="ts" setup="context">
/* ---- Core ---- */
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useTitle } from '@vueuse/core';

/* ---- Components ---- */
import TheFooter from '@/components/TheFooter.vue';
import TheMain from '@/components/TheMain.vue';
import TheHeader from '@/components/TheHeader.vue';

/* ---- State ---- */
const id = ref();
const clientId = ref();
const { params, query } = useRoute();
const router = useRouter();
const title = useTitle('Сервер Авторизации');

/* ---- Hooks ---- */
onMounted((): void => {
  id.value = params.id ?? query.requestId;
  clientId.value = params.clientId ?? query.clientId;
});
</script>

<style lang="scss">
#app {
}
</style>
